import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ampli } from '../../ampli';
import { decodeSourceName } from '../../utils/decodeURI';
import { ExpandableText } from '../CollapsibleText/ExpandableText';
import { ImagesContainer } from '../Image/ImagesContainer';
import { LoaderSmall } from '../LoaderSmall/LoaderSmall';
import styles from './ExtendedMessageView.module.scss';

export function OriginalTextBlock({
  message,
  isShare,
  currentUser,
  narrative,
  textClassParent,
  enableDeepFakeDetector,
  customStyles
}) {
  const { t } = useTranslation();
  const parentSource = message?.parent_message?.source ?? message?.source;

  return (
    <div className={styles.originalTextBlock} style={customStyles ?? {}}>
      {message.isTranslation === true && !message.parent_message?.translated ? (
        <div className={styles.loaderContainer}>
          <LoaderSmall />
        </div>
      ) : (
        <>
          <span
            className={styles.sourceLink}
            data-tooltip-id="source-info"
            data-tooltip-content={
              parentSource
                ? `${decodeSourceName(parentSource.name)}\n${parentSource.url ?? t('N/A')}`
                : t('N/A')
            }
          >
            {isShare ? (
              decodeSourceName(parentSource?.name) ?? t('N/A')
            ) : parentSource ? (
              <Link
                to={`/sources/${parentSource?.id}`}
                onClick={() => {
                  ampli.track({
                    event_type: 'Open source profile',
                    event_properties: {
                      user_id: currentUser?.id,
                      workspace_id: currentUser?.workspace_id,
                      source_id: parentSource?.id,
                    },
                  });
                }}
              >
                {decodeSourceName(parentSource.name)}
              </Link>
            ) : (
              t('N/A')
            )}
          </span>

          {message?.parent_message?.images &&
          message?.parent_message?.images?.length > 0 ? (
            <ImagesContainer
              images={message?.parent_message?.images}
              showCount={3}
              enableDeepFakeDetector={enableDeepFakeDetector}
            />
          ) : (
            ''
          )}

          {(message.parent_message?.highlighted_text || message.parent_message?.text) ? (
            <ExpandableText
              length={150}
              text={
                message.isTranslation
                  ? message.parent_message?.translated
                  : message.parent_message?.highlighted_text || message.parent_message?.text
              }
              textClassName={textClassParent}
              onExpand={(expanded) => {
                ampli.track({
                  event_type: expanded
                    ? 'Expand original post in-place'
                    : 'Collapse original post in-place',
                  event_properties: {
                    user_id: currentUser?.id,
                    workspace_id: currentUser?.workspace_id,
                    narrative_id: narrative?.id,
                  },
                });
              }}
            />
          ) : (
            ''
          )}
        </>
      )}
    </div>
  );
}
